
import Search from 'vux/src/components/search/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'

import hotArea from './hotArea.vue'
import configInfo from '../configInfo.js'
import {wxShareConfig} from '../js/common/utils'

export default {
name: 'app',
created:function(){
this.orgCode = this.$route.query.orgCode;
this.orgName = this.$route.query.orgName;
},
data: function () {
return {
isShow: false,
results: [],
value: '',
selectSvg: require('../assets/pulldown.svg'),
headSvgUrl:'../assets/logo.png',
defaultImg: 'this.src="' + require('../assets/img/leagueDefaultLogo.svg') + '"',

content:[],
pulldownConfig:{
downContent: '下拉刷新',
upContent: '释放后更新',
loadingContent: 'Loading...',
},
pullupConfig:{
upContent:'上拉加载更多', downContent: '释放后加载'
},
status2: {
pulldownStatus: 'default',
pullupStatus:'default'
},
currentPage:1,
step:10,
leagueName:'',
orgCode:'',
orgName:'',
timeclock:require('../assets/img/timeclock.svg'),
screenWidth:0,
havaData: true,
}
},
components : {
Badge,
Icon,
Search,
Scroller,
hotArea,
Spinner
},
mounted(){

this.$nextTick(() => {
this.$refs.scroller.reset()
this.getData();
this.isUsePullup();
})

$('.weui-icon-clear').click(()=> {
this.$refs.search.setBlur()
this.leagueName = '';
this.getData();
});
this.screenWidth = window.innerWidth;
this.initWxShareConfig();
},
methods:{
initWxShareConfig:function(){
var fullPath = window.location.href;
var shareImg = window.location.origin + configInfo.routerBase + "static/logo.png";
wxShareConfig({
title: '最新赛事',
desc: this.orgName+'校园足球最新赛事',
link: fullPath,
imgUrl: shareImg,
type: 'link',
dataUrl: ''
}, () => {

}, () => {

});
},
changeRegion(orgCode, orgName){
this.pop();
this.orgCode = orgCode;
this.orgName = orgName;
this.getData();
},
resultClick (item) {
/*window.alert('you click the result item: ' + JSON.stringify(item))*/
},
getResult (val) {
/*this.leagueName = val;
this.content.splice(0, this.content.length);
this.getData();*/
},
onSubmit () {
this.$refs.search.setBlur()
this.leagueName = this.$refs.search.value;
this.getData();
},
onFocus () {
/*console.log($('.vux-search-fixed').length);
$('.vux-search-fixed').css('top', '0px');
console.log('on focus')*/
},
onCancel () {
this.leagueName = '';
this.getData();
},
pop () {
this.isShow = !this.isShow;
if(this.isShow){
this.selectSvg = require('../assets/pullup.svg');
} else {
this.selectSvg = require('../assets/pulldown.svg');
}
},
leagueInfo(leagueId){
configInfo.orgCode = this.orgCode;
configInfo.orgName = this.orgName;
this.$router.push({path:"/league_info", query:{leagueId:leagueId, orgCode:this.orgCode, orgName:this.orgName}});
},
getData(){
var _this = this;
this.currentPage = 1;
var start = (this.currentPage-1)*this.step;
_this.content.splice(0, _this.content.length);
this.hagkHttp(this.hagkApi.getLeagueByOrgCodeAndName(this.orgCode), {"leagueName":this.leagueName, "start":start, "step":this.step})
.then((res) => {
if (res) {
for(var i=0;i<res.length;i++){
res[i].name = this.adapterScreenWidth(res[i].name);

if(res[i].logo){
if(res[i].logo != null){
res[i].logo = this.getLeagueLogoUrl(res[i].logo);
} else {
res[i].logo = this.defaultImg
}
} else {
res[i].logo = this.defaultImg
}
_this.content.push(res[i]);
}
}
_this.$nextTick(() => {
_this.$refs.scroller.reset({top:0})
_this.isUsePullup();
})

_this.havaData = !(_this.content.length == 0 && _this.leagueName.length == 0);
}, (error) => {
_this.isUsePullup();
console.log(error);
alert('数据获取失败！');
});
},
pulldown(){
var _this = this;
var start = (_this.currentPage-1)*_this.step;
this.hagkHttp(this.hagkApi.getLeagueByOrgCodeAndName(this.orgCode), {"leagueName":this.leagueName, "start":start, "step":this.step})
.then((res) => {
if(res){
_this.content.splice(0, _this.content.length);
for(var i=0;i<res.length;i++){
res[i].name = this.adapterScreenWidth(res[i].name);
if(res[i].logo){
if(res[i].logo != null){
res[i].logo = this.getLeagueLogoUrl(res[i].logo);
} else {
res[i].logo = this.defaultImg
}
} else {
res[i].logo = this.defaultImg
}
_this.content.push(res[i]);
}

_this.$refs.scroller.donePulldown();
_this.$nextTick(() => {
_this.$refs.scroller.reset({top:0})
})
this.currentPage = 1;
}
_this.isUsePullup();
}, (error) => {
_this.isUsePullup();
console.log(error)
alert('数据获取失败！');
});
},
pullup(){
var _this = this;
this.currentPage++;
var start = (_this.currentPage-1)*_this.step;
this.hagkHttp(this.hagkApi.getLeagueByOrgCodeAndName(this.orgCode), {"leagueName":this.leagueName, "start":start, "step":this.step})
.then((res) => {
if(res){
if(res.length > 0){
for(var i=0;i<res.length;i++){
res[i].name = this.adapterScreenWidth(res[i].name);
if(res[i].logo){
if(res[i].logo != null){
res[i].logo = this.getLeagueLogoUrl(res[i].logo);
} else {
res[i].logo = this.defaultImg
}
} else {
res[i].logo = this.defaultImg
}
_this.content.push(res[i]);
}
} else {
this.currentPage--;
}
}
_this.$refs.scroller.donePullup();
_this.$nextTick(() => {
_this.$refs.scroller.reset()
_this.isUsePullup();
})
}, (error) => {
_this.$refs.scroller.donePullup();
_this.$nextTick(() => {
_this.$refs.scroller.reset()
_this.isUsePullup();
})
console.log(error);
alert('数据获取失败！');
})

},
isUsePullup(){
if(this.content.length>7)
this.$refs.scroller.enablePullup(); 
else
this.$refs.scroller.disablePullup(); 
},
getLeagueLogoUrl(assetId) {
if (assetId) {
return this.hagkApi.getImgAssetById(assetId).url;
} else {
return null;
}
},
cutLeagueName(name,cutLength){
if(name.length<=cutLength){
return name;
}
if(!/^[a-zA-Z\d]/.test(name)){
return name.substring(0, cutLength)+"…"
} else {
var strLength = 0;
var charCount = 0;
for(var index=0;index<name.length;index++){
if(/^[a-zA-Z\d]+$/.test(name[index])){
strLength += 0.5;
charCount++;
} else {
strLength++;
}
}
if(strLength<=cutLength){
return name;
} else {
return name.substring(0, cutLength+charCount/2)+"…";
}
}
},
adapterScreenWidth(name){
if(name){
if(this.screenWidth<=320){
name = this.cutLeagueName(name, 13);
} else if(this.screenWidth <= 375) {
name = this.cutLeagueName(name, 16);
} else {
name = this.cutLeagueName(name, 21);
}
}
return name;
}
},
computed: {
filterResult() {
return this.defaultResult.filter(value => new RegExp(this.value, 'i').test(value));
}
}
}




// WEBPACK FOOTER //
// ./src/views/leagueList.vue